 
class Perfil { 
    
    public static campos = () => {
        return [ 
            {
                nome: "nome",
                type: "text",
                label: "Nome",
                sm: 6 ,
                lg: 6, 
                disabled: false
            },  
            {
                nome: "descricao",
                type: "text",
                label: "Descrição",
                sm: 6 ,
                lg: 6, 
                disabled: false
            },  
            
        ];
    }   
 
} 
export   {   Perfil }; 